import { MockFactory } from '@tino-frontend/mocks'
import { BillListResponseV3, BillStatus } from '@types'
import { allLineItemsMock } from '@fixtures/apis/bill/line-item/all-line-items'
import { billBaseMock } from '@fixtures/apis/bill/detail-v3/bill-base'

// Bill
const bill0 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'bill-teste-OVERDUE',
    status: BillStatus.Overdue,
    line_item_groups: allLineItemsMock.source,
  },
  { mergeArray: false }
)
const bill1 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'bill-teste-SNOOZED',
    status: BillStatus.Snoozed,
    line_item_groups: allLineItemsMock.source,
  },
  { mergeArray: false }
)
const bill2 = billBaseMock.build(
  {
    ...billBaseMock.source,
    id: 'bill-teste-OPEN',
    status: BillStatus.Open,
    line_item_groups: allLineItemsMock.source,
  },
  { mergeArray: false }
)

export const billListStrikethroughMock = new MockFactory<BillListResponseV3>({
  current_bill_id: 'bill-teste-OPEN',
  bills: [bill0, bill1, bill2],
})
